import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import { SERVER_DATE_FORMAT } from '@nxt-insurance/constants'

import { TRAVEL_HEALTH_NXT_CONSTANTS } from '@flows/configs/travelHealthNxt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const { MINIMUM_AGE, MAXIMUM_AGE } = TRAVEL_HEALTH_NXT_CONSTANTS

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  if (issue.code === 'too_big' || issue.code === 'too_small') {
    return {
      message: t('sharedFlows_travelHealth:steps.birth_date.errors.ageOutOfRange', {
        minAge: MINIMUM_AGE,
        maxAge: MAXIMUM_AGE,
      }),
    }
  }
  return { message: ctx.defaultError }
}

const birth_date = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: z
        .union([z.number(), z.string(), z.date()])
        .pipe(
          z.coerce
            .date()
            .min(sub(new Date(), { years: MAXIMUM_AGE + 1 }))
            .max(sub(new Date(), { years: MINIMUM_AGE }))
        )
        .transform((value) => format(value, SERVER_DATE_FORMAT)),
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.birth_date.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    nextStep: 'tariff_selection',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default birth_date
